module.exports = __webpack_public_path__ + "assets/b69.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b69.png
// module id = 659
// module chunks = 0